import * as React from 'react';
import cn from 'classnames';
import { FormField } from '@cian/ui-kit';
import * as styles from './styles.css';

export interface ITextareaProps extends React.ComponentProps<'textarea'> {
  errorMessage?: string | null;
  invalid?: boolean;
}

export const Textarea: React.FC<ITextareaProps> = props => {
  const { errorMessage, invalid, ...rest } = props;

  return (
    <FormField errorMessage={errorMessage}>
      <textarea {...rest} className={cn(styles['textarea'], invalid && styles['invalid'], props.className)} />
    </FormField>
  );
};

Textarea.displayName = 'Textarea';
